import L from "leaflet";
import { Marker } from "react-leaflet";
import { Dognhvileplass } from "../../../services/RuteplanAPI";
import dognhvileplassIconResource from "../../../assets/restingarea24hrs-marker.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const dognhvileplassIcon = L.icon({
    iconUrl: dognhvileplassIconResource,
    iconRetinaUrl: dognhvileplassIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IDognhvileplassMarkersProps {
    dognhvileplasser: Array<Dognhvileplass>;
}

export default function DognhvileplassMarkers (props: IDognhvileplassMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { dognhvileplasser } = props;

    return (
        <>
            {dognhvileplasser.map((dognhvileplass: Dognhvileplass, index: number) => {
                return (
                    <Marker key={dognhvileplass.navn + index} 
                    position={[dognhvileplass.location!.y, dognhvileplass.location!.x]} 
                    icon={dognhvileplassIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(dognhvileplass);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}